// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productImageCarouselStyles } from "@sc/Overrides/Components/ProductImageCarousel";
import { color, xScreen } from "@sc/XDL/Utilities";
import { css } from "styled-components";

const imageCss = css`
    width: 100%;
    height: 100%;
    width: 70px;
    height: 70px;
    cursor: pointer;
    justify-content: center;
    border-radius: 4px;
    img {
        width: 100%;
        height: auto;
        max-height: 100%;
        max-width: 100%;
        object-fit: contain;
    }
`;

productImageCarouselStyles.img = {
    css: css`
        ${imageCss}
    `,
};
productImageCarouselStyles.imageSelected = {
    css: css`
        ${imageCss}
        border: 1px solid ${color("common.ui9")};
    `,
};

productImageCarouselStyles.imagesContainer = {
    css: css`
        display: flex;
        flex-wrap: wrap;
        column-gap: 20px;
        row-gap: 16px;
        margin-top: 16px;
        ${xScreen("lte", 767)} {
            column-gap: 20px;
        }
    `,
};
